import React from "react";
import { DataBox } from "./DataBox";
import { DetailDrawer } from "./DetailDrawer";
import { GroupDrawer } from "./GroupDrawer";
import { PageHeader } from "./PageHeader";

export function Cardcase() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
            <GroupDrawer />
        </>
    );
}

